/**
 * REVIEW COMPANIES REDUX REDUCERS
 *
 * @version 0.1
 */

import {
    RSS_LISTING_INITIAL_PHASE,
    RSS_LISTING_COUNT,
    RSS_LISTING_WARNING_HIDDEN,
    RSS_LISTING_LOAD_CATEGORIES,
    RSS_LISTING_WARNING_SHOWN,
    RSS_LISTING_SELECT_ITEM,
    RSS_LISTING_DESELECT_ITEM,
    RSS_LISTING_REFRESH_FEEDS,
    RSS_LISTING_RESET_SELECTED_ITEMS,
    RSS_LISTING_TABLE_URL_CHANGE,
    RSS_LISTING_SET_SELECTION
} from './FeedListing.actions';

function reviewCompanies(state = null, action) {

    switch (action.type) {

        case RSS_LISTING_INITIAL_PHASE:
            return Object.assign(
                {}, {
                    stage:         'rss-listing-warning-hidden',
                    categoryStore: null,
                    selectedItems: [],
                    totalCount:    null,
                    urlParams:     {
                        sortBy:        'lastUpdated',
                        direction:     'desc',
                        refreshToggle: 0
                    }
                }
            );

        case RSS_LISTING_COUNT:
            return Object.assign(
                {}, state, {
                    totalCount: action.payload
                }
            );

        case RSS_LISTING_WARNING_HIDDEN:
            return Object.assign(
                {}, state, {
                    stage: 'rss-listing-warning-hidden'
                }
            );

        case RSS_LISTING_LOAD_CATEGORIES:
            return Object.assign(
                {}, state, {
                    categoryStore: action.payload
                }
            );

        case RSS_LISTING_WARNING_SHOWN:
            return Object.assign(
                {}, state, {
                    stage: 'rss-listing-warning-shown'
                }
            );

        case RSS_LISTING_SELECT_ITEM:
            return Object.assign(
                {}, state, {
                    selectedItems: [...state.selectedItems, action.payload]
                }
            );

        case RSS_LISTING_SET_SELECTION:
            return Object.assign(
                {}, state, {
                    selectedItems: action.payload
                }
            );

        case RSS_LISTING_DESELECT_ITEM:
        {
            let deselectedItem = action.payload;

            if (deselectedItem > -1) {
                return Object.assign(
                    {}, state, {
                        selectedItems: [
                            ...state.selectedItems.slice(0, deselectedItem),
                            ...state.selectedItems.slice(deselectedItem + 1)
                        ]
                    }
                );
            }
        }
            break;

        case RSS_LISTING_RESET_SELECTED_ITEMS:
            return Object.assign(
                {}, state, {
                    selectedItems: []
                }
            );

        case RSS_LISTING_REFRESH_FEEDS:
            return Object.assign(
                {}, state, {
                    urlParams: Object.assign(
                        {}, state.urlParams, {
                            refreshToggle: state.urlParams.refreshToggle === 0 ? 1 : 0
                        }
                    )
                }
            );

        case RSS_LISTING_TABLE_URL_CHANGE:
        {
            return Object.assign(
                {}, state, {
                    urlParams: Object.assign({}, state.urlParams, action.payload)
                }
            );
        }


        default:
            return state;

    }

}

export default reviewCompanies;


// WEBPACK FOOTER //
// ./src/scripts/pages/FeedListing/FeedListing.reducers.js